var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "white",
    stroke: "#244034"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8012 31C64.9014 31 69 35.2804 69 41.6488V56.3512C69 62.7196 64.9014 67 58.7994 67H43.197C37.0968 67 33 62.7196 33 56.3512V41.6488C33 35.2804 37.0968 31 43.197 31H58.8012ZM58.8012 33.7H43.197C38.643 33.7 35.7 36.8194 35.7 41.6488V56.3512C35.7 61.1806 38.643 64.3 43.197 64.3H58.7994C63.3552 64.3 66.3 61.1806 66.3 56.3512V41.6488C66.3 36.8194 63.3552 33.7 58.8012 33.7ZM58.3611 43.7746C58.8885 44.302 58.8885 45.1552 58.3611 45.6826L49.8183 54.2254C49.5555 54.49 49.2099 54.6214 48.8643 54.6214C48.5205 54.6214 48.1731 54.49 47.9103 54.2254L43.6371 49.954C43.1097 49.4266 43.1097 48.5734 43.6371 48.046C44.1645 47.5186 45.0177 47.5186 45.5451 48.046L48.8643 51.3616L56.4531 43.7746C56.9805 43.2472 57.8337 43.2472 58.3611 43.7746Z",
    fill: "#244034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationicon);
export default __webpack_public_path__ + "static/media/confirmationicon.abfc66e9dcf15f4a5ffb08f62c0af838.svg";
export { ForwardRef as ReactComponent };